import * as tslib_1 from "tslib";
import DroppableWell from './DroppableWell';
import DraggableItem from './DraggableItem';
import { ExtendedPeoplePicker, } from 'office-ui-fabric-react/lib/ExtendedPicker';
import * as React from 'react';
import { FloatingPeoplePicker, } from 'office-ui-fabric-react/lib/FloatingPicker';
import { SelectedPeopleList, } from 'office-ui-fabric-react/lib/SelectedItemsList';
import { SuggestionsStore } from 'office-ui-fabric-react/lib/FloatingPicker';
var styles = require('./ReadWriteCommonWell.scss');
var ReadWriteCommonWell = /** @class */ (function (_super) {
    tslib_1.__extends(ReadWriteCommonWell, _super);
    function ReadWriteCommonWell(props) {
        var _this = _super.call(this, props) || this;
        _this.focus = function () {
            if (_this.picker) {
                _this.picker.focus();
            }
        };
        _this.getFindControlProps = function () {
            return tslib_1.__assign({ suggestionsStore: new SuggestionsStore(), onValidateInput: _this.isValidItemName, onRenderSuggestionsItem: _this.renderSuggestionItem, onResolveSuggestions: _this.getQuerySuggestions, onZeroQuerySuggestion: _this.getZeroQuerySuggestions, createGenericItem: _this.createGenericItem, calloutWidth: 300, resolveDelay: 500 }, _this.getExtendedFindControlProps());
        };
        _this.getSelectedItemsListProps = function () {
            return tslib_1.__assign({ onRenderItem: _this.renderDraggableSelectedItem, onItemSelected: _this.onItemAdded, onItemDeleted: _this.onItemRemoved, onChange: _this.onSelectedItemsChanged, defaultSelectedItems: _this.getDefaultSelectedItems() }, _this.getExtendedSelectedItemsListProps());
        };
        _this.renderRecipientWell = function () {
            var TypedExtendedPicker = _this.typedPicker();
            return (React.createElement("div", { className: styles.well },
                React.createElement(TypedExtendedPicker, tslib_1.__assign({ floatingPickerProps: _this.getFindControlProps(), selectedItemsListProps: _this.getSelectedItemsListProps(), onRenderFloatingPicker: _this.onRenderFindControl, onRenderSelectedItems: _this.onRenderSelectedItemsList, onFocus: _this.props.onInputFocus, componentRef: function (ref) { return (_this.picker = ref); }, onItemSelected: _this.onItemAdded, onPaste: _this.onPaste }, _this.extendedPickerProps()))));
        };
        _this.onRenderFindControl = function (props) {
            return React.createElement(FloatingPeoplePicker, tslib_1.__assign({}, props));
        };
        _this.onRenderSelectedItemsList = function (props) {
            return React.createElement(SelectedPeopleList, tslib_1.__assign({}, props));
        };
        /**
         * Callback on paste to add possible items
         */
        _this.onPaste = function (pastedText) {
            var parsedItems = _this.parsePastedTextForItems(pastedText);
            _this.picker.selectedItemsList.current.addItems(parsedItems);
            return parsedItems;
        };
        _this.renderDraggableSelectedItem = function (props) {
            return (React.createElement(DraggableItem, { dragViewState: { isBeingDragged: false }, item: props.item, displayText: _this.getDisplayTextFromItem(props.item), draggableItemType: _this.props.draggableItemType, removeDroppedItemAction: _this.removeDroppedItem, canDrag: _this.getCanDragItem }, _this.renderSelectedItem(props)));
        };
        return _this;
    }
    ReadWriteCommonWell.prototype.render = function () {
        return (React.createElement(DroppableWell, { dropViewState: this.props.dropViewState, addDroppedItemAction: this.addDroppedItem, draggableItemType: this.props.draggableItemType },
            React.createElement("div", { className: styles.container, onClick: this.focus, onKeyDown: this.onKeyDown }, this.renderRecipientWell())));
    };
    ReadWriteCommonWell.prototype.typedPicker = function () {
        return ExtendedPeoplePicker;
    };
    ReadWriteCommonWell.prototype.getSelectedItemIndex = function (suggestions, selectedItem) {
        var selectedItemIndex = -1;
        suggestions.forEach(function (obj, index) {
            if (obj.item === selectedItem) {
                selectedItemIndex = index;
            }
        });
        return selectedItemIndex;
    };
    return ReadWriteCommonWell;
}(React.Component));
export default ReadWriteCommonWell;
//# sourceMappingURL=ReadWriteCommonWell.js.map